import { pick } from 'ramda';
import { useCallback } from 'react';
import { useAppSelector } from 'js/store/hooks';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useBatchRequest = () => {
    const send = useGenericSend();
    const { casinoName } = useAppSelector(pick(['casinoName']));

    return useCallback(async ({ authParameters, ...request }: Types.IBatchRequestData): Promise<Types.IBatchResponseData> => {
        return await send<Types.IBatchRequestData, Types.IBatchResponseData>({
            ID: 35508,
            errorLevel: 1,
            authParameters: {
                casinoName,
                ...authParameters || {}
            },
            responses: [35516, 35517],
            description: 'Batch request',
            ...request
        });
    }, [casinoName, send]);
};
